<template>
  <router-view></router-view>
  <!-- The above router view is: To display the bottom sheet -->
  <div class="blackTransBg">
    <h2 class="mealHeading">Main Course</h2>
  </div>

  <div class="card-container">
    <base-card v-for="type in mealType" :key="type.name" :cardContent="type" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      mealType: [
        { name: "Chicken", path: "chicken-main-course" },
        { name: "Mutton", path: "mutton-main-course" },
        { name: "Veg", path: "veg-main-course" },
        { name: "Roti", path: "roti-main-course" },
        { name: "Rice", path: "rice-main-course" },
      ],
    };
  },
};
</script>
